export enum ReasonsTypeId {
    RateIncreased = 1016,
    RecipientDetailsIncorrect = 10,
    ChangePickupLocation = 20,
    RequirePaymentMethodChange = 1038,
    IncorrectAmount = 1028,
    Other = 51
}



// WEBPACK FOOTER //
// ./src/model/types/primary-cancellation-reasons-icons-types.ts